import Image from "next/image";
import { gradient } from "./constants";

export default function LogoWithName({ size = 80 }: { size?: number }) {
  return (
    <div className="flex items-center">
      <div style={{ width: size, height: size }} className="relative shrink-0">
        <Image
          src="/assets/logo/300.png"
          alt="PicOviyan Logo"
          fill
          sizes={`${size}px`}
          className="object-contain"
        />
      </div>
      <span
        style={{ fontSize: size * 0.8, lineHeight: 1.5 }}
        className={`${gradient} bg-clip-text text-transparent font-bold`}
      >
        icOviyan
      </span>
    </div>
  );
}
